module.exports = __webpack_public_path__ + "static/media/gold.656fb58f.png";